import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/Home.vue"),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "sign" */ "./views/SignIn.vue")
    },
    {
      path: "/logout",
      name: "logout",
      component: () =>
        import(/* webpackChunkName: "logout" */ "./views/SignOut.vue"),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/profiles",
      name: "profiles",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "profiles" */ "./views/ProfileList.vue"),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/users/qonto",
      name: "qontousers",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "profiles" */ "./views/QontoUserList.vue"),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/profiles/:uid",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "profileview" */ "./views/Profile.vue"),
      props: true,
      meta: {
        authRequired: true
      },
      children: [
        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: "",
          component: () =>
            import(
              /* webpackChunkName: "profileview" */ "./views/ProfileInfo.vue"
            ),
          props: true
        },
        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: "orders",
          component: () =>
            import(
              /* webpackChunkName: "profileview" */ "./views/ProfileOrders.vue"
            ),
          props: true
        },
        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: "invoices",
          component: () =>
            import(
              /* webpackChunkName: "profileview" */ "./views/ProfileInvoices.vue"
            ),
          props: true
        },
        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: "sources",
          component: () =>
            import(
              /* webpackChunkName: "profileview" */ "./views/ProfileSources.vue"
            ),
          props: true
        },
        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: "addresses",
          component: () =>
            import(
              /* webpackChunkName: "profileview" */ "./views/ProfileAddresses.vue"
            ),
          props: true
        }
      ]
    },
    {
      path: "/orders",
      name: "orders",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "invoices" */ "./views/OrderList.vue"),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/invoices",
      name: "invoices",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "invoices" */ "./views/InvoiceList.vue"),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/business",
      name: "business",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "business" */ "./views/BusinessList.vue"),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/plans",
      name: "plans",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "plans" */ "./views/PlanList.vue"),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/partners",
      name: "partners",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "partners" */ "./views/PartnerList.vue"),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/services",
      name: "services",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "services" */ "./views/ServiceList.vue"),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/offers",
      name: "offers",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "offers" */ "./views/OfferList.vue"),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/coupons",
      name: "coupons",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "offers" */ "./views/CouponList.vue"),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/logs",
      name: "logs",
      component: () =>
        import(/* webpackChunkName: "offers" */ "./views/LogsList.vue"),
      meta: {
        authRequired: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
    if (!store.getters.isAuthenticated) {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
